module.exports = __webpack_public_path__ + "static/media/react.3463c977.svg";